import React, { Component } from "react";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import PeriodeFilter from "../../common/periodeFilter";
import TabKwitansiBatalFilter from "./tabKwitansiBatalFilter";
import { getValueFromDDL, removeNullFields } from "../../../../common/mapper";
import { defaultTableChange } from "../../../../../modules/custom/customTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";
import moment from "moment";
import {formGroup as formGroupBKK } from "../tabBKK/config";
import {formGroup as formGroupBKM } from "../tabBKM/config";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import TabBKKDetail from "../tabBKK/tabBKKDetail";
import TabBKMDetail from "../tabBKM/tabBKMDetail";

class TabKwitansiBatal extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    {
      name: "tanggalPayment",
      label: "Tanggal BKM/BKK",
      options: {
        sort: false,
      },
    },
    {
      name: "dataPaymentCash",
      label: "Nomor BKM/BKK",
      options: {
        customBodyRender: (value) => <>{value?.paymentCashId}</>,
        sort: false,
      },
    },
    {
      name: "dataDocumentBizpar",
      label: "Jenis Dokumen",
      options: {
        customBodyRender: (value) => <>{value?.value}</>,
        sort: false,
      },
    },
    {
      name: "documentRef1No",
      label: "No. Dokumen Ref 1",
      options: {
        sort: false,
      },
    },
    {
      name: "documentRef1Date",
      label: "Tanggal Dokumen Ref 1",
      options: {
        sort: false,
      },
    },
    {
      name: "dataPaymentCash",
      label: "Kode Kas",
      options: {
        customBodyRender: (value) => <>{value?.dataKas?.name}</>,
        sort: false,
      },
    },
    {
      name: "transactionPersonName",
      label: "Terima Dari/Bayar Kepada",
      options: {
        sort: false,
      },
    },
    {
      name: "dataPaymentCash",
      label: "Aksi",
      options: {
          customBodyRender: (val, {rowIndex}) => {
              return (
                  <SimpleButton
                      category="action_button"
                      className="btnAct"
                      onClick={() => this.handleShowDetailKwitansiBatal(val)}
                      icon={
                          <i
                              className="fa fa-lw fa-eye"
                              style={{
                                  backgroundColor: "transparent",
                                  color: "red",
                                  fontSize: 20,
                              }}
                          />
                      }
                  />
              );
          },
      },
    },
  ];

  constructor(props) {
    super(props);
    this.initialSearchData = {
      startBkkBkmDate: moment().format("DD-MM-YYYY"),
      endBkkBkmDate: moment().format("DD-MM-YYYY"),
    };
    this.initialPagination = {
      totalData: 1,
      page: 1,
      limit: 5,
    };
    this.state = {
      filterVisible: false,
      filterData: {},
      searchData: this.initialSearchData,
      pagination: this.initialPagination,
      skipNextPaginationFetch: false,
      dataTable: [],
      loading: false,
      detailKwitansiBatal: {
        detailId: null,
        detailType: null
      }
    };
  }

  componentDidMount() {
    this.fetchData({
      startBkkBkmDate: moment().format('DD-MM-YYYY'),
      endBkkBkmDate: moment().format('DD-MM-YYYY')
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabIndex !== this.state.tabIndex) {
      this.refetch({ ...this.initialSearchData });
    }
    const { submittedFilterData, pagination, skipNextPaginationFetch } =
      this.state;
    if (
      (prevState.pagination.page !== pagination.page ||
        prevState.pagination.limit !== pagination.limit) &&
      !this.state.skipNextPaginationFetch
    ) {
      this.fetchData(submittedFilterData, pagination.page, pagination.limit);
    }
    if (skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }

    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      this.handleResetPeriode();
      this.handleResetPagination();
      this.fetchData({
        ...submittedFilterData,
        ...this.initialSearchData,
      });
    }
  }

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: filter,
      loading: true,
    }));
    const request = {
      paramFilters: removeNullFields({
        kodeCabang: this.props.kodeCabang?.value || "",
        ...filter,
      }),
      page,
      limit,
    };

    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getPaymentCashCancel,
      setError: this.props.setError,
      menuName: "Transaksi Cash - Kwitansi Batal",
      args: request,
    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        pagination: {
          ...prevValue.pagination,
          totalData: response.data.totalData,
        },
        loading: false,
      }));
    } else {
      this.props.setError({
        menuName: "Transaksi Cash - Kwitansi Batal",
        errorMessage: response.data.message,
      });
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: [],
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        },
        loading: false,
      }));
    }
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevValue) => ({ ...prevValue, filterData: {} }));
  };

  handleSubmitFilter = async () => {
    const { filterData } = this.state;
    this.handleResetPagination();
    this.handleResetPeriode();
    let request = {
      ...filterData,
      kodeCabang: this.props.kodeCabang?.value,
      kodeKas: getValueFromDDL(filterData, "kodeKas"),
      keyDocumentType: getValueFromDDL(filterData, "keyDocumentType"),
      paymentType: getValueFromDDL(filterData, "paymentType"),
    };

    await this.refetch(request);
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: false,
      searchData: {
        startBkkBkmDate: null,
        endBkkBkmDate: null,
      },
    }));
  };

  handlePeriodChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: moment(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSubmitPeriod = async () => {
        this.setState({skipNextPaginationFetch: true});
        this.handleResetPagination();
        const paymentDate = removeNullFields(
            this.getPeriodInput(this.state.searchData)
        );
        await this.refetch(paymentDate);
    };

    getPeriodInput = (data) => ({
        startBkkBkmDate: data?.startBkkBkmDate
            ? data.startBkkBkmDate
            // ? moment(data.startBkkBkmDate).format("DD-MM-YYYY")
            : null,
        endBkkBkmDate: data?.endBkkBkmDate
            ? data.endBkkBkmDate
            // ? moment(data.endBkkBkmDate).format("DD-MM-YYYY")
            : null,
    });

  refetch = async (filter = {}) => {
    await this.fetchData({ ...filter });
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleResetPeriode = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: this.initialSearchData,
    }));
  };

  handleResetPagination = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: this.initialPagination,
      skipNextPaginationFetch: true,
    }));
  };

  handleRefresh = () => {
    this.handleResetPagination();
    this.handleResetPeriode();
    this.refetch({ tanggalBBM: this.initialSearchData });
  };


  handleShowDetailKwitansiBatal = (dataPayment) => {
    const detailId = dataPayment?.paymentId || null;
    let detailType = null;

    if (dataPayment) {
      detailType = dataPayment.paymentCashId?.startsWith("BKK") ? "BKK" : "BKM";
    }

    this.setState((prev) => ({
      ...prev,
      detailKwitansiBatal: { detailId, detailType },
    }));
  }

  renderDetail = () => {
    const { detailId, detailType } = this.state.detailKwitansiBatal;
    if (!detailId) return null;
    
    const commonProps = {
      id: detailId,
      visible: true,
      isEditable: false,
      onClickClose: () => this.handleShowDetailKwitansiBatal(),
      isPreview: true
    };
  
    if (detailType === 'BKK') {
      return (
        <TabBKKDetail
          {...this.props}
          {...commonProps}
          formGroup={formGroupBKK}
          title="Detail BKK KWITANSI BATAL"
          namaCabang={this.props.kodeCabang?.label}
          kodeCabang={this.props.kodeCabang?.value}
        />
      );
    }
  
    if (detailType === 'BKM') {
      return (
        <TabBKMDetail
          {...commonProps}
          formGroup={formGroupBKM}
          title="Detail BKM KWITANSI BATAL"
          kodeCabang={this.props.kodeCabang?.value}
        />
      );
    }
  
    return null;
  };
  

  render() {
    return (
      <div>
        <PeriodeFilter
          state={this.state}
          withFilterButton
          startDateName="startBkkBkmDate"
          endDateName="endBkkBkmDate"
          onValueChange={this.handlePeriodChange}
          onSubmit={this.handleSubmitPeriod}
          onShowFilter={this.handleFilterVisibility}
        />
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.tableColumns}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          toCount={this.state.pagination.totalData}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
        />
        {this.state.filterVisible && (
          <TabKwitansiBatalFilter
            tab="Kwitansi Batal"
            kodeCabang={this.props.kodeCabang?.value}
            data={this.state.filterData}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            onValueChange={this.handleFilterValueChange}
            onSubmit={this.handleSubmitFilter}
            onClear={this.handleClearFilter}
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.renderDetail()}
      </div>
    );
  }
}

export default TabKwitansiBatal;